import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {useDispatch, useSelector} from "react-redux";
import {changeContract} from "../contractSlice";
import {Tooltip} from "recharts";


export default function ParticipationsTabs(props) {
    const [participationsTabValue, setParticipationsTabValue] = React.useState(0);

    const selectorTabIndex = useSelector((state) => state.contractSlc.value.participationsTabsIndex);

    const dispatchData = useDispatch();

    // const TabLabel = ({ text, tooltip }) => (
    //     <Tooltip enterDelay={1000} title={tooltip}>
    //         <span>{text}</span>
    //     </Tooltip>
    // );


    const handleChange = (event, newValue) => {
        setParticipationsTabValue(newValue);
        console.log("newValue = ", newValue);
        if (newValue == 0) {
            dispatchData(changeContract({participationsTabsIndex: 0, contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                participationsTabsVisible: true, module: 'Participations'}));
            dispatchData(changeContract({contractGridAPI: "PartsStandards"}));
            console.log("contractGridAPI = PartsStandards");
        }


        if (newValue == 1) {
            dispatchData(changeContract({participationsTabsIndex: 1, contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                participationsTabsVisible: true, module: 'Participations',contractGridAPI: "PartsAbstracts"}));
            console.log("Abstracts Selected");
            console.log("contractGridAPI = PartsAbstracts");
        }

        if (newValue == 2) {
            dispatchData(changeContract({participationsTabsIndex: 2, contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                participationsTabsVisible: true, module: 'Participations',contractGridAPI: "PartsRiders"}));
            console.log("contractGridAPI = PartsRiders");}

        if (newValue == 3) {
            dispatchData(changeContract({participationsTabsIndex: 3, contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                participationsTabsVisible: true, module: 'Participations',contractGridAPI: "PartsDocuments"}));
            console.log("contractGridAPI = PartsDocuments");}

        // if (newValue == 4) {
        //     dispatchData(changeContract({contractGridVisible: true,
        //         contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
        //         participationsTabsVisible: true, module: 'Participations',contractGridAPI: "PartsProjects"}));
        //
        // };
        if (newValue == 4) {
            dispatchData(changeContract({participationsTabsIndex: 4, contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                participationsTabsVisible: true, module: 'Participations',contractGridAPI: "PartsPackages"}));
            console.log("contractGridAPI = PartsPackages");}

        if (newValue == 5) {
            dispatchData(changeContract({participationsTabsIndex: 5, contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                participationsTabsVisible: true, module: 'Participations',contractGridAPI: "Branches"}));
            console.log("contractGridAPI = Branches");}

        if (newValue == 6) {
            dispatchData(changeContract({participationsTabsIndex: 6, contractGridAPI: "PartsPre", contractGridVisible: true,
                contractDrilldownVisible: false, participationsTabsVisible: false,contractConfigVisible: true,
                contractSearchVisible: false, module: 'Participations'}));};
    }

    return (
        <Box sx={{pt: 2, width: '100%', height: 75, bgcolor: 'background.paper' }}>
            <Tabs value={selectorTabIndex} defaultValue={selectorTabIndex}
                  onChange={handleChange} centered>
            {/*<Tabs value={participationsTabValue} defaultValue={"Standard Contracts"}*/}
            {/*<Tabs value={selectorTabIndex} defaultValue={selectorTabIndex}*/}
            {/*      selectorTabIndex*/}
                  // onChange={handleChange} centered>
            {/*        <Tab*/}
            {/*            label={*/}
            {/*                <TabLabel*/}
            {/*                    text="Standard Contracts"*/}
            {/*                    tooltip="Standard contract templates used for creating abstracts."*/}
            {/*                />*/}
            {/*            }*/}
            {/*        />*/}
                <Tab label="Standard Contracts"
                     title="Standard contract templates used for creating abstracts"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
                <Tab label="Abstracts"
                     title="Abstracted models of executed contracts used for generating calculation contract models"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
                <Tab label="Riders"
                     title="Contractual riders containing boilerplate contractual terms added to calcuation contract models"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
                {/*<Tab label="Schedules" />*/}
                <Tab label="Documents"
                     title="Contract documents produced for reporting, etc. (not in use)"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
                <Tab label="Packages"
                     title="Standardized document packages (not in use)"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
                <Tab label="Branches"
                     title="Standard fragments of contracts to be inserted into abstracts and standard contracts (not in use)"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
                {/*<Tab label="Stakeholder Contracts" />*/}
                <Tab label="Configurations"
                     title="Configurations and methods added by the system to contract models during build"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}
                />
            </Tabs>
        </Box>
    );
}
